import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {path} from 'ramda';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {changeModalState} from '../../actions/modal'
import {clearObjectToDelete} from '../../actions/objectToDelete'
import './style.css';

class PopUp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      show: false,
      wrapClassName: 'modal-default',
      size: 'default'
    };

    this.toggle = this.toggle.bind(this);
    this.confirm = this.confirm.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  componentDidMount() {
    const { show } = this.props;
    this.setState({ show });
  }

  componentDidUpdate(prevProps, prevState) {
    const { show } = this.props;
    if (prevProps.show !== show && this.state.show !== show) {
      this.setState({ show });
    }
  }

  toggle() {
    this.setState(({show}) => {
      show: !show
    });
  }

  confirm() {
    this.props.onAddContacts();
    this.setState({ show: false });
  }

  cancel() {
    this.setState({ show: false });

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    let modalId = path(['modal', 'modalId'], this.props);
    let showModal = this.state.show;

    return (
      <Modal
        isOpen={showModal}
        toggle={this.toggle}
        wrapClassName={this.state.wrapClassName}
        size={this.state.size}
      >

        <ModalHeader>{this.props.title}</ModalHeader>
        <ModalBody>
          <h5>{this.props.content}</h5>
          <div className="clearfix pull-right">
            <button className="btn btn-default mr-1" onClick={this.cancel}>
              Cancel
            </button>
            <button className="btn btn-default" onClick={this.confirm}>
              {this.props.yesCaption}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    makeActionById: (data, handler) => {
      if (typeof handler(data) == 'function') {
        handler(data)(dispatch);
      }
    },
    clearObjectToRemove: (data) => {
      dispatch(clearObjectToDelete(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PopUp);



// WEBPACK FOOTER //
// ./src/common/PopUp/index.js